import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const SpendByGLAccountChart = ({ transactions }) => {
  // Group transactions by GL account
  const groupedData = transactions.reduce((acc, txn) => {
    const glAccount = txn.glAccount
      ? `${txn.glAccount.accountNumber} - ${txn.glAccount.accountName}`
      : 'Uncategorized';

    if (!acc[glAccount]) {
      acc[glAccount] = {
        glAccount,
        totalSpend: 0,
        transactionCount: 0
      };
    }

    acc[glAccount].totalSpend += parseFloat(txn.amount || 0);
    acc[glAccount].transactionCount += 1;

    return acc;
  }, {});

  // Convert to array and sort by total spend
  const chartData = Object.values(groupedData)
    .sort((a, b) => b.totalSpend - a.totalSpend);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  // Truncate long GL account names for display
  const truncateText = (text, maxLength = 30) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-3 max-w-xs">
          <p className="text-sm font-semibold text-gray-900 break-words">
            {payload[0].payload.glAccount}
          </p>
          <p className="text-sm text-gray-700 mt-1">
            Total Spend: <span className="font-semibold">{formatCurrency(payload[0].value)}</span>
          </p>
          <p className="text-sm text-gray-600">
            Transactions: {payload[0].payload.transactionCount}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Spend by GL Account</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            dataKey="glAccount"
            tickFormatter={(value) => truncateText(value, 20)}
            tick={{ fontSize: 10, fill: '#6b7280' }}
            stroke="#9ca3af"
            angle={-45}
            textAnchor="end"
            height={100}
            interval={0}
          />
          <YAxis
            tickFormatter={formatCurrency}
            tick={{ fontSize: 12, fill: '#6b7280' }}
            stroke="#9ca3af"
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar
            dataKey="totalSpend"
            fill="#8b5cf6"
            name="Total Spend"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SpendByGLAccountChart;
